import React from 'react';
import { string, func } from 'prop-types';

import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';

import styles from './Article.css';

const Article = ({ titleHighlight, title, date, dateHighlight, onClick }) => (
  <li className={styles.article}>
    <p className={styles.articleTitle}>
      {titleHighlight && <span className={styles.titleHighlight}>{titleHighlight} </span>}
      {title}
    </p>
    <div className={styles.articleDetails}>
      <p className={styles.articleDate}>
        {date}
        {dateHighlight && <span className={styles.dateHighlight}> {dateHighlight}</span>}
      </p>
      <LinkFreeStanding
        className={styles.articleLink}
        icon={{ direction: 'right', name: 'arrow-right', type: '20' }}
        onClick={onClick}
        size="m"
        withBouncing
      >
        read more
      </LinkFreeStanding>
      <LinkFreeStanding
        className={styles.articleDarklink}
        onClick={onClick}
        size="s"
        medium
      >
        read more
      </LinkFreeStanding>
    </div>
  </li>
);

Article.propTypes = {
  titleHighlight: string,
  title: string,
  dateHighlight: string,
  date: string,
  link: string,
  onClick: func
};

Article.displayName = 'Article';

export default Article;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/NewsBanner/Article/Article.js